import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollAdjustment } from "../../components/PayrollAdjustment";

export const PayrollAdjustmentPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Adjustment"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<PayrollAdjustment />}
    />
  );
};
